//
//  components/layouts/TownlitOfficialLayout.tsx
//  TownLIT
//
//  Created by Hossein Sakkaki on 2026-08-19.
//  Last Update by Hossein Sakkaki on 2026-08-19.
//

"use client";

import React from "react";
import { usePathname } from "next/navigation";

import HeaderOfficial from "../ui/HeaderOfficial/HeaderOfficial";
import FooterOfficial from "../ui/FooterOfficial/FooterOfficial";

import "./TownlitOfficialLayout.css";

export type TownlitOfficialHeaderType =
  | "default"
  | "alternate"
  | "minimal";

type TownlitOfficialLayoutProps = {
  children: React.ReactNode;
  headerType?: TownlitOfficialHeaderType;
};

function resolveHeaderType(
  pathname: string,
): TownlitOfficialHeaderType {
  // Special pages override the general official route.
  if (pathname === "/townlit-official/special-page") {
    return "minimal";
  }

  // Nested official pages use the back-navigation header.
  if (pathname.startsWith("/townlit-official/")) {
    return "alternate";
  }

  return "default";
}

const TownlitOfficialLayout = ({
  children,
  headerType,
}: TownlitOfficialLayoutProps) => {
  const pathname = usePathname();

  const resolvedHeaderType =
    headerType ?? resolveHeaderType(pathname);

  return (
    <div className="townlit-official-layout">
      <HeaderOfficial type={resolvedHeaderType} />

      <main className="townlit-main">
        {children}
      </main>

      <FooterOfficial />
    </div>
  );
};

export default TownlitOfficialLayout;